export default __webpack_public_path__ + "3d42ebbc829b6406e28d053a6c0ebbf0.png";